import api from '../services/api'
import { RESET } from './game'

// Actions
const FETCHING_SURVEY_START = 'ascension/survey/fetching'
const FETCHING_SURVEY_SUCCESS = 'ascension/survey/success'
const FETCHING_SURVEY_ERROR = 'ascension/survey/error'

const UPDATE_QUESTION_RESPONSE = 'ascension/survey/response'
const UPDATE_DETAIL_RESPONSE = 'ascension/survey/detail'

const SET_QUESTION_RESET = 'ascension/survey/questions_reset'

const SUBMIT_SURVEY_START = 'ascension/survey/submit/start'
const SUBMIT_SURVEY_SUCCESS = 'ascension/survey/submit/success'
const SUBMIT_SURVEY_ERROR = 'ascension/survey/submit/error'

// Reducer
const initialState = {
  isLoading: false,
  isLoaded: false,
  isSubmitting: false,
  submitted: false,
  submitError: null,
  error: null,
  questions: [],
  resetAt: null,
  details: {
    name: '',
    email: ''
  }
}

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCHING_SURVEY_START: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
        error: null
      }
    }
    case FETCHING_SURVEY_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        questions: action.data
      }
    }
    case FETCHING_SURVEY_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.data
      }
    }

    case SUBMIT_SURVEY_START: {
      return {
        ...state,
        isSubmitting: true,
        submitError: null
      }
    }
    case SUBMIT_SURVEY_SUCCESS: {
      return {
        ...state,
        isSubmitting: false,
        submitted: true
      }
    }
    case SUBMIT_SURVEY_ERROR: {
      return {
        ...state,
        isSubmitting: false,
        submitError: action.data
      }
    }

    case UPDATE_DETAIL_RESPONSE: {
      return {
        ...state,
        details: {
          ...state.details,
          [action.data.prop]: action.data.response
        }
      }
    }

    case SET_QUESTION_RESET: {
      return {
        ...state,
        resetAt: action.data.resetAt
      }
    }

    case UPDATE_QUESTION_RESPONSE: {
      return {
        ...state,
        questions: state.questions.map(q => {
          if (q.index === action.data.questionIndex) {
            q.response = action.data.response
          }
          return q
        })
      }
    }
    case RESET: {
      return initialState
    }
    default:
      return state
  }
}

export default reducer

export function fetchingSurveyStart () {
  return {
    type: FETCHING_SURVEY_START
  }
}

export function fetchingSurveySuccess (data) {
  return {
    type: FETCHING_SURVEY_SUCCESS,
    data
  }
}

export function fetchingSurveyError (error) {
  return {
    type: FETCHING_SURVEY_ERROR,
    data: error
  }
}

export function submitSurveyStart () {
  return {
    type: SUBMIT_SURVEY_START
  }
}

export function submitSurveySuccess (data) {
  return {
    type: SUBMIT_SURVEY_SUCCESS,
    data
  }
}

export function submitSurveyError (error) {
  return {
    type: SUBMIT_SURVEY_ERROR,
    data: error
  }
}

// Action Creators
export function onQuestionUpdate (questionIndex, response) {
  return {
    type: UPDATE_QUESTION_RESPONSE,
    data: {
      questionIndex,
      response
    }
  }
}

export function onDetailUpdate (prop, response) {
  return {
    type: UPDATE_DETAIL_RESPONSE,
    data: {
      prop,
      response
    }
  }
}

export function setQuestionsReset (resetAt) {
  return {
    type: SET_QUESTION_RESET,
    data: { resetAt }
  }
}

export function fetchSurvey () {
  return async dispatch => {
    dispatch(fetchingSurveyStart())

    try {
      const response = await api.getSurvey()
      dispatch(fetchingSurveySuccess(response))
    } catch (e) {
      dispatch(fetchingSurveyError(e))
    }
  }
}

export function submit (teamId, responses) {
  return async dispatch => {
    dispatch(submitSurveyStart())

    try {
      const response = await api.submitSurvey(teamId, responses)
      dispatch(submitSurveySuccess(response))
    } catch (e) {
      dispatch(submitSurveyError(e))
    }
  }
}
